import { select } from "@/ui/select.js";
import { eventEmitter } from "@/utils/event-emitter.js";
import { config } from "@/utils/config.js";
import { appState } from "@/utils/state.js";

export function templateSelect(
  parent = document.querySelector(".select-level-bar")
) {
  if (document.querySelector(".template")) {
    document.querySelector(".template").remove();
  }
  const templates = config.levels[appState.getState("levelInd")].puzzles;
  appState.setState("template", templates[appState.getState("templateInd")])
    .name;

  const classes = ["template", "select-level-bar__item"];

  const elem = select({
    parent: parent,
    classes: classes,
    options: templates.map((template, i) => ({
      text: template.name,
      index: i,
    })),
    onChange: (e) => eventEmitter.emit("templateChange", e.target.value),
  });
  return elem;
}
